import pptxgen from 'pptxgenjs'
import { OPEN_SANS_REGULAR } from '../common/constants'
import { percentageToInches, getCoordinates, SLIDE_SIZE_PX, decodeHtml } from '../helpers'

const pptx = new pptxgen()

const stacked = (data) => {
  const names = [...new Set(data.flatMap((item) => item.entries.map((entry) => entry.name)))]

  const labels = data.map((item) => item.name)

  // correct values in each bar, but all bars with the same height
  // const values = data.map((item) => item.entries.map((entry) => entry.value / 100))
  // correct heights and relative %, but different values from UI
  const values = data.map((item) =>
    item.entries.map((entry) => ((item.value / 100) * entry.value) / 100)
  )

  // format data to match pptx schema
  return names.map((name, index) => ({
    name,
    labels: [...labels],
    values: values.map((val) => val[index]),
  }))
}

const single = (data) => [
  data.reduce(
    (acc, { name, value }) => ({
      name,
      labels: [...acc.labels, name],
      values: [...acc.values, value / 100],
    }),
    { name: '', labels: [], values: [] }
  ),
]

const format = {
  single,
  stacked,
}

function renderSpacedStackBarChart({ x, y, height, width, parent, svgNode, slide }) {
  const coordinates = getCoordinates({ x, y }, parent)

  const xOffset = (width / 100) * 8
  const yOffset = (height / 100) * 4
  // Divide offset by two to center
  const translateY = percentageToInches(yOffset / 2 / SLIDE_SIZE_PX.y, 'y')
  const translateX = percentageToInches(xOffset / 2 / SLIDE_SIZE_PX.x, 'x')

  const chartPosition = {
    x: coordinates.x + translateX,
    y: coordinates.y + (height > 300 && translateY) - 0.3, // 0.3 is a magic number to fix "height - 150" of the chart
    h: percentageToInches((height - yOffset) / SLIDE_SIZE_PX.y, 'y') + 0.5,
    w: percentageToInches((width - xOffset) / SLIDE_SIZE_PX.x, 'x'),
  }

  const data = svgNode.properties['data-json']
  const decodedData = JSON.parse(decodeHtml(data))

  const colors = svgNode.properties['data-colors']
  const decodedColors = JSON.parse(decodeHtml(colors))

  const labels = svgNode.properties['data-labels']
  const decodedLabels = JSON.parse(decodeHtml(labels))

  const mode = svgNode.properties['data-mode']
  const decodedMode = JSON.parse(decodeHtml(mode))

  const formatted = format[decodedMode](decodedData)

  const optsChartBar2 = {
    ...chartPosition,
    barDir: 'col',
    barGrouping: 'stacked',
    barGapWidthPct: 25,

    lineDataSymbol: 'none',
    title: '',
    showTitle: false,
    lineDataSymbolSize: null,
    lineSmooth: true,

    catAxisLabelPos: 'low',
    catAxisLineShow: true,
    showCatAxisTitle: true,
    catAxisTitle: decodedLabels.x,
    catAxisLabelFontSize: 9,
    catAxisLabelColor: '878787',
    catAxisLineColor: 'aaaaaa',

    showValAxisTitle: true,
    valAxisTitle: decodedLabels.y,
    valAxisLabelFormatCode: '#%',
    valAxisLabelFontSize: 9,
    valAxisLabelColor: '878787',
    valAxisLineColor: 'aaaaaa',

    showValue: decodedMode === 'single' ? true : false,
    dataLabelPosition: 'b',
    dataLabelFormatCode: '#%',
    dataLabelColor: 'ffffff',
    dataLabelFontSize: 9,

    legendPos: 'b',
    showLegend: decodedMode === 'single' ? false : true,

    legendFontFace: OPEN_SANS_REGULAR,
    titleFontFace: OPEN_SANS_REGULAR,
    catAxisLabelFontFace: OPEN_SANS_REGULAR,
    catAxisTitleFontFace: OPEN_SANS_REGULAR,
    valAxisLabelFontFace: OPEN_SANS_REGULAR,
    valAxisTitleFontFace: OPEN_SANS_REGULAR,
    dataLabelFontFace: OPEN_SANS_REGULAR,

    chartColors: decodedColors,
    valGridLine: {
      style: 'dash',
      size: 1,
      color: 'aaaaaa',
    },
  }

  slide.addChart(pptx.ChartType.bar, formatted.reverse(), optsChartBar2)
}

export default renderSpacedStackBarChart
